var map = {
	"./bg-BG.json": 813,
	"./ca-ES.json": 814,
	"./cs-CZ.json": 815,
	"./de-DE.json": 816,
	"./en-US.json": 543,
	"./es-ES.json": 817,
	"./fi-FL.json": 818,
	"./fr-FR.json": 819,
	"./he-IL.json": 820,
	"./it-IT.json": 821,
	"./ja-JP.json": 822,
	"./nb-NO.json": 823,
	"./pl-PL.json": 824,
	"./pt-BR.json": 825,
	"./ru-RU.json": 826,
	"./sv-SE.json": 827,
	"./tr-TR.json": 828,
	"./zh-CN.json": 829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 812;